<template>
  <div>
    <order-list :activityId="activityId" :orderType="2"></order-list>
  </div>
</template>

<script>
import OrderList from '../../order/orderlist'

export default {
  name: 'index',
  components: {OrderList},
  data () {
    return {
      activityId: 0
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.activityId = parseInt(this.$route.query.activityId || 0)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/activity/orderlist/index.vue